import React from 'react';
import { Button, EnhancedButton } from 'module-tsl-ui-elements';
import CopyableSnippet from '../../../components/utils/CopyableSnippet';
import LinkableTitle from '../../../components/linkableTitle';

const clickableIconMap = {
  md: 'sm',
  lg: 'md',
  xl: 'lg',
};

export default class ButtonOverview extends React.Component {
  state = {
    size: 'md',
    disabled: false,
  }
  render () {
    const { disabled, size } = this.state;
    const enhancedButtonSize = size === 'sm' ? 'md' : size;
    const clickableIconSize = clickableIconMap[enhancedButtonSize];
    return (
      <div className="buttons-overview-story">
        <LinkableTitle name="overview" title="Overview" />
        <div className="buttons-block">
          <div className="buttons-block__btn">
            <Button>
              Ctay
            </Button>
            <div><CopyableSnippet code="primary" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="secondary">
              Ctay
            </Button>
            <div><CopyableSnippet code="secondary" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="tertiary">
              Ctay
            </Button>
            <div><CopyableSnippet code="tertiary" /></div>
          </div>
        </div>
        <div className="buttons-block">
          <div className="buttons-block__btn">
            <Button theme="primary-monotone">
              Ctay
            </Button>
            <div><CopyableSnippet code="primary-monotone" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="secondary-monotone">
              Ctay
            </Button>
            <div><CopyableSnippet code="secondary-monotone" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="tertiary-monotone">
              Ctay
            </Button>
            <div><CopyableSnippet code="tertiary-monotone" /></div>
          </div>
        </div>
        <div className="buttons-block buttons-block--inverse">
          <div className="buttons-block__btn">
            <Button theme="primary-inverse">
              Ctay
            </Button>
            <div><CopyableSnippet code="primary-inverse" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="secondary-inverse">
              Ctay
            </Button>
            <div><CopyableSnippet code="secondary-inverse" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="tertiary-inverse">
              Ctay
            </Button>
            <div><CopyableSnippet code="tertiary-inverse" /></div>
          </div>
        </div>
        <div className="buttons-block">
          <div className="buttons-block__btn">
            <Button theme="primary-warning">
              Ctay
            </Button>
            <div><CopyableSnippet code="primary-warning" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="secondary-warning">
              Ctay
            </Button>
            <div><CopyableSnippet code="secondary-warning" /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="tertiary-warning">
              Ctay
            </Button>
            <div><CopyableSnippet code="tertiary-warning" /></div>
          </div>
        </div>
        <div className="buttons-block">
          <div className="buttons-block__btn">
            <Button icon="plus">
              Ctay
            </Button>
            <div><CopyableSnippet code={`icon="plus"`} /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="secondary" icon="plus">
              Ctay
            </Button>
            <div><CopyableSnippet code={`theme="secondary"`} /></div>
            <div><CopyableSnippet code={`icon="plus"`} /></div>
          </div>
          <div className="buttons-block__btn">
            <Button theme="tertiary" icon="plus">
              Ctay
            </Button>
            <div><CopyableSnippet code={`theme="tertiary"`} /></div>
            <div><CopyableSnippet code={`icon="plus"`} /></div>
          </div>
        </div>
        <LinkableTitle name="enhanced-buttons" title="Enhanced buttons wrapper" />
        <div className="buttons-block">
          <EnhancedButton>
            <Button
              disabled={disabled}
              size={clickableIconSize}
              onClick={() => console.log('clicked icon')}
              icon="remove"
            />
            <Button
              onClick={() => console.log('clicked button')}
              disabled={disabled}
              size={enhancedButtonSize}
            >
              Ctay (8)
            </Button>
          </EnhancedButton>
          <div><CopyableSnippet code={`import { Button, EnhancedButton } from 'module-tsl-ui-elements';
<EnhancedButton>
  <Button
    disabled={disabled}
    size={clickableIconSize}
    onClick={() => console.log('clicked icon')}
    icon="remove"
  />
  <Button
    onClick={() => console.log('clicked button')}
    disabled={disabled}
    size={enhancedButtonSize}
  >
    Ctay (8)
  </Button>
</EnhancedButton>
`} /></div>
        </div>
        <div className="buttons-block">
          <EnhancedButton iconRight>
            <Button
              disabled={disabled}
              size={clickableIconSize}
              onClick={() => console.log('clicked icon')}
              icon="remove"
            />
            <Button
              onClick={() => console.log('clicked button')}
              disabled={disabled}
              size={enhancedButtonSize}
            >
              Ctay (8)
            </Button>
          </EnhancedButton>
          <div><CopyableSnippet code={`import { Button, EnhancedButton } from 'module-tsl-ui-elements';
<EnhancedButton iconRight>
  <Button
    disabled={disabled}
    size={clickableIconSize}
    onClick={() => console.log('clicked icon')}
    icon="remove"
  />
  <Button
    onClick={() => console.log('clicked button')}
    disabled={disabled}
    size={enhancedButtonSize}
  >
    Ctay (8)
  </Button>
</EnhancedButton>
`} /></div>
        </div>
      </div>
    );
  }
}